// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

export { default } from './ProductPrice';
